import React, {useEffect, useState} from 'react';
import './AdminUsers.css';
import AdminHeader from "../AdminHeader/AdminHeader";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const AdminUsers = () => {

    const [email, setEmail] = useState('');
    const [showUser, setShowUser] = useState(null);
    const [showCurrentUsers, setShowCurrentUsers] = useState(null);

    const navigate = useNavigate();

    const goToUsers = (id) => {
        navigate('/admin_user_profile', {state:
                {
                    userId: id
                }
        })
    }

    useEffect(() => {
        axios.get(`/api/get_current_players/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (Object.keys(res.data.detail).length !== 0) {
                    setShowCurrentUsers(
                        <table className={'show-current-users-table'}>
                            <thead>
                            <tr>
                                <th className={'show-current-users-element'}>Имя</th>
                                <th className={'show-current-users-element'}>Телефон</th>
                                <th className={'show-current-users-element'}>Почта</th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.values(res.data.detail).map((pers) => (
                                <tr onClick={() => goToUsers(pers.user.id)}>
                                    <td className={'show-current-users-element'}>{pers.user.name}</td>
                                    <td className={'show-current-users-element'}>{pers.user.phone}</td>
                                    <td className={'show-current-users-element'}>{pers.user.email}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    );
                } else {
                    setShowCurrentUsers('Никто не играет');
                }
            })
            .catch(e => {
                console.log(e);
            })
    }, []);

    const handleChange = (event) => {
        setEmail(event.target.value);
    }

    const searchUser = () => {
        console.log(email);
        axios.get(`/api/user_search/?email=${email}`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail.length !== 0) {
                    setShowUser(
                        <table className={'show-search-user-table'}>
                            <tbody>
                            <tr onClick={() => goToUsers(res.data.detail[0].id)}>
                                <td className={'show-search-user-element'}>{res.data.detail[0].name}</td>
                                <td className={'show-search-user-element'}>{res.data.detail[0].phone}</td>
                                <td className={'show-search-user-element'}>{res.data.detail[0].email}</td>
                            </tr>
                            </tbody>
                        </table>
                    )
                } else {
                    setShowUser('Нет такого пользователя');
                }
            })
            .catch(e => {
                console.log(e);
            })
    }

    const goBack = () => {
        navigate('/admin');
    }

    return (
        <div className={'admin-find-user-page'}>
            <AdminHeader />

            <div className={'admin-search-user-and-show'}>
                <div className={'admin-search-user-block'}>
                    <input
                        type={'text'}
                        className={'admin-search-user-input'}
                        placeholder={'Введите почту...'}
                        value={email}
                        onChange={handleChange}
                    />
                    <input
                        type={'button'}
                        className={'admin-search-user-button'}
                        value={'Поиск'}
                        onClick={() => searchUser()}
                    />
                </div>
                <div className={'admin-show-user-block'}>
                    {showUser}
                </div>
            </div>

            <div className={'admin-show-current-players'}>
                {showCurrentUsers}
            </div>

            <div className={'admin-users-back-button-container'}>
                <div className={'admin-users-back-button'} onClick={() => goBack()}>Назад</div>
            </div>

        </div>
    );
};

export default AdminUsers;